import { AnswerItemApiFactory, AnswerItem } from '@/api'
import { BaseInitRequest } from '@/requests/baseRequest'
import { AxiosPromise } from 'axios'

/**
 * 回答保存項目取得
 */
export class AnswerItemList extends BaseInitRequest {
  private proximityId: string

  /**
   * @param proximityId
   * @returns
   */
  constructor(proximityId: string) {
    super()
    this.proximityId = proximityId
  }

  protected request(): AxiosPromise<Array<AnswerItem>> {
    const api = AnswerItemApiFactory()
    return api.answerItemList(this.proximityId)
  }
}
